export enum FilterTypeEnum {
  TEXT,
  SELECT,
  AUTOCOMPLETE,
  DATE,
  DATETIME_RANGE,
  DATE_RANGE,
  HIDDEN,
}